import { HsRegularGeometryData } from '../geometry-utils/regular-geometry-data.class';

export function hsGenerateAngleGeometryData(size: number = 1): HsRegularGeometryData {
  const vertices: number[] = [];
  const normals: number[] = [];
  const a: [number, number, number] = [1 - size, 1, 1];
  const b: [number, number, number] = [-1 + size, 1, 1];
  const c: [number, number, number] = [-1 + size, 1 - size, 1];
  const d: [number, number, number] = [1 - size, 1 - size, 1];
  const e: [number, number, number] = [1 - size, 1, 1 - size];
  const f: [number, number, number] = [-1 + size, 1, 1 - size];
  // upper side
  vertices.push(...a, ...b, ...f, ...a, ...f, ...e);
  normals.push(0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0);
  // front side
  vertices.push(...a, ...c, ...b, ...a, ...d, ...c);
  normals.push(0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1);
  return new HsRegularGeometryData(vertices, normals);
}
